export enum ImportSlideTabEnum {
    BOOKMARKED = 'BOOKMARKED',
    ALL = 'ALL',
}
